import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  min-height: 80vh;
`;

export const Section = styled.section`
  margin-bottom: 40px;
  padding: 20px;
  background: var(--background-color);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

export const SectionTitle = styled.h2`
  color: var(--accent-color);
  font-size: 24px;
  margin-bottom: 15px;
  border-bottom: 3px solid var(--accent-color);
  padding-bottom: 10px;
`;

export const Text = styled.p`
  color: var(--text-color);
  font-size: 16px;
  line-height: 1.8;
  margin-bottom: 15px;
`;

export const List = styled.ul`
  color: var(--text-color);
  margin-left: 20px;
  font-size: 16px;
  line-height: 1.8;
  li { margin-bottom: 10px; }
`;

export const FeatureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-top: 20px;
`;

export const FeatureCard = styled.div`
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  h3 { margin-bottom: 10px; }
  p  { color: rgba(255, 255, 255, 0.9); }
`;
